import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('credit-policies', storeModule.createStoreModule('credit-policies'))
